import { useEffect } from 'react';

import {
  setAllCompanies,
  setAllCompaniesForGroupByIndividual,
  setAllLocations,
  setAllLocationsForGroupByIndividual,
  setSelectedCompanies,
  setSelectedCompaniesForGroupByIndividual,
  setSelectedLocations,
  setSelectedLocationsForGroupByIndividual,
} from 'Deer/intent/Goals/slice/GoalsIntentSlice';
import { useDispatch } from 'react-redux';

export const useSetCompanyMetaFilterInitialDataGoals = (rowData) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const companyMap = {};
    rowData?.forEach((row) => {
      if (row?.companies?.length > 0) {
        row?.companies?.forEach((company) => {
          if (company && !companyMap[company?.id]) {
            companyMap[company?.id] = company;
          }
        });
      }
    });

    dispatch(setAllCompanies(Object.keys(companyMap)?.map((key) => companyMap[key])));
    dispatch(setSelectedCompanies(Object.keys(companyMap)?.map((key) => companyMap[key])));
  }, [rowData, dispatch]);
};

export const useSetLocationMetaFilterInitialDataGoals = (rowData) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const locationsMap = {};

    rowData?.forEach((row) => {
      if (row?.empLocations?.length > 0) {
        row?.empLocations.forEach((location) => {
          if (location && !locationsMap[location?.toLowerCase()]) {
            locationsMap[location?.toLowerCase()] = location;
          }
        });
      }
    });

    dispatch(setSelectedLocations(Object.keys(locationsMap)?.map((key) => locationsMap[key])));
    dispatch(setAllLocations(Object.keys(locationsMap)?.map((key) => locationsMap[key])));
  }, [rowData, dispatch]);
};

// For GroupByIndividual Table: company is a single object, location is a string
export const useSetCompanyMetaFilterInitialDataGoalsForGroupByIndividual = (rowData) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const companyMap = {};
    rowData?.forEach((row) => {
      const company = row?.company;
      if (company && company.id && !companyMap[company.id]) {
        companyMap[company.id] = company;
      }
    });
    const companiesArr = Object.values(companyMap) as {
      companyName: string;
      id: number;
      companyCode: string;
    }[];

    dispatch(setAllCompaniesForGroupByIndividual(companiesArr));
    dispatch(setSelectedCompaniesForGroupByIndividual(companiesArr));
  }, [rowData, dispatch]);
};

export const useSetLocationMetaFilterInitialDataGoalsForGroupByIndividual = (rowData) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const locationsMap = {};
    rowData?.forEach((row) => {
      const location = row?.empLocation ?? 'NA';
      if (location && !locationsMap[location.toLowerCase()]) {
        locationsMap[location.toLowerCase()] = location;
      }
    });
    const locationsArr = Object.values(locationsMap) as string[];
    dispatch(setSelectedLocationsForGroupByIndividual(locationsArr));
    dispatch(setAllLocationsForGroupByIndividual(locationsArr));
  }, [rowData, dispatch]);
};
